
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dang-ky",
      function () {
        return require("private-next-pages/dang-ky/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/dang-ky"])
      });
    }
  